import {
  funktionspruefungZyklus, letzteFunktionspruefung, naechsteFunktionspruefungBeiMenge, naechsteFunktionspruefungImMonat,
} from '@/config/werkzeug/werkzeugListeFields';
import messmittelkategorie from '@/static/messmittel/messmittelkategorie';

export default [
  {
    path: 'messmittelverwaltung',
    component: () => import('@/layouts/messmittelverwaltung/Messmittelverwaltung.vue'),
    children: [
      {
        name: 'messmittelverwaltung',
        path: '',
        component: () => import('@/views/messmittelverwaltung/MessmittelverwaltungStartseite.vue'),
      },
      {
        name: 'messmittelliste',
        path: 'messmittel',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittelliste.vue'),
        props: {
          canAdd: true,
        },
      },
      {
        name: 'messmittelliste.typ',
        path: 'messmittel/typ/:werkzeugtyp',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittelliste.vue'),
        props: (route) => ({
          canAdd: true,
          werkzeugtyp: route.params.werkzeugtyp,
        }),
      },
      {
        name: 'messmittelliste.gruppe',
        path: 'messmittel/gruppe/:werkzeuggruppe',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittelliste.vue'),
        props: (route) => ({
          canAdd: true,
          werkzeuggruppe: route.params.werkzeuggruppe,
        }),
      },
      {
        name: 'messmittelliste.status',
        path: 'messmittel/status/:status',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittelliste.vue'),
        props: (route) => ({
          canAdd: true,
          status: route.params.status,
        }),
      },
      {
        name: 'messmittelliste.pruefung_vorgemerkt',
        path: 'messmittel/pruefung_vorgemerkt',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittelliste.vue'),
        props: {
          canAdd: true,
          pruefungVorgemerkt: true,
        },
      },
      {
        name: 'messmittelliste.pruefung_ueberfaellig',
        path: 'messmittel/pruefung_ueberfaellig',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittelliste.vue'),
        props: {
          canAdd: true,
          pruefungUeberfaellig: true,
        },
      },
      {
        name: 'messmittelliste.funktionspruefung_vorgemerkt',
        path: 'messmittel/funktionspruefung_vorgemerkt',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittelliste.vue'),
        props: {
          canAdd: true,
          additionalFields: [letzteFunktionspruefung, funktionspruefungZyklus, naechsteFunktionspruefungBeiMenge, naechsteFunktionspruefungImMonat],
          funktionspruefungVorgemerkt: true,
        },
      },
      {
        name: 'messmittelliste.funktionspruefung_faellig',
        path: 'messmittel/funktionspruefung_faellig',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittelliste.vue'),
        props: {
          canAdd: true,
          additionalFields: [letzteFunktionspruefung, funktionspruefungZyklus, naechsteFunktionspruefungBeiMenge, naechsteFunktionspruefungImMonat],
          funktionspruefungFaellig: true,
        },
      },
      {
        name: 'messmittelliste.extern',
        path: 'messmittel/extern',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittelliste.vue'),
        props: {
          canAdd: true,
          extern: true,
        },
      },
      {
        name: 'messmittelliste.extern.typ',
        path: 'messmittel/extern/typ/:werkzeugtyp',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittelliste.vue'),
        props: (route) => ({
          canAdd: true,
          werkzeugtyp: route.params.werkzeugtyp,
          extern: true,
        }),
      },
      {
        name: 'messmittelliste.extern.gruppe',
        path: 'messmittel/extern/gruppe/:werkzeuggruppe',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittelliste.vue'),
        props: (route) => ({
          canAdd: true,
          werkzeuggruppe: route.params.werkzeuggruppe,
          extern: true,
        }),
      },
      {
        name: 'messmittelliste.extern.status',
        path: 'messmittel/extern/status/:status',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittelliste.vue'),
        props: (route) => ({
          canAdd: true,
          status: route.params.status,
          extern: true,
        }),
      },
      {
        name: 'messmittelliste.extern.pruefung_vorgemerkt',
        path: 'messmittel/extern/pruefung_vorgemerkt',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittelliste.vue'),
        props: {
          canAdd: true,
          pruefungVorgemerkt: true,
          extern: true,
        },
      },
      {
        name: 'messmittelliste.extern.pruefung_ueberfaellig',
        path: 'messmittel/extern/pruefung_ueberfaellig',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittelliste.vue'),
        props: {
          canAdd: true,
          pruefungUeberfaellig: true,
          extern: true,
        },
      },
      {
        name: 'messmittel.import',
        path: 'messmittel/import',
        component: () => import('@/views/messmittelverwaltung/messmittel/import/Index.vue'),
      },
      {
        name: 'messmittel.neu',
        path: 'messmittel/neu',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittel.vue'),
        props: {
          id: null,
          edit: true,
          kategorie: messmittelkategorie.messmittel,
        },
      },
      {
        name: 'pruefmittel.neu',
        path: 'pruefmittel/neu',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittel.vue'),
        props: {
          id: null,
          edit: true,
          kategorie: messmittelkategorie.pruefmittel,
        },
      },
      {
        name: 'messmittel.neu.tab',
        path: 'messmittel/neu/:primarytab',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittel.vue'),
        props: (route) => ({
          id: null,
          edit: true,
          tab: null,
          primarytab: route.params.primarytab,
        }),
      },
      {
        name: 'messmittel.id',
        path: 'messmittel/:id',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittel.vue'),
        props: (route) => ({
          id: route.params.id,
          edit: false,
        }),
      },
      {
        name: 'messmittel.id.edit',
        path: 'messmittel/:id/edit',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittel.vue'),
        props: (route) => ({
          id: route.params.id,
          edit: true,
        }),
      },
      {
        name: 'messmittel.kalibrierschein',
        path: 'messmittel/:werkzeugId/kalibrierschein',
        component: () => import('@/views/messmittelverwaltung/messmittel/kalibrierung/Kalibrierschein.vue'),
        props: true,
      },
      {
        name: 'messmittel.id.tab',
        path: 'messmittel/:id/:primarytab/:tab',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittel.vue'),
        props: (route) => ({

          id: route.params.id,
          edit: false,
          tab: route.params.tab,
          primarytab: route.params.primarytab,
        }),
      },
      {
        name: 'messmittel.id.edit.tab',
        path: 'messmittel/:id/edit/:primarytab/:tab',
        component: () => import('@/views/messmittelverwaltung/messmittel/Messmittel.vue'),
        props: (route) => ({
          id: route.params.id,
          edit: true,
          tab: route.params.tab,
          primarytab: route.params.primarytab,
        }),
      },
      {
        path: 'settings',
        component: () => import('@/layouts/messmittelverwaltung/Settings.vue'),
        children: [
          {
            path: 'historiekommentarmuster',
            name: 'messmittel.settings.historiekommentarmuster',
            component: () => import('@/views/messmittelverwaltung/messmittel/settings/HistorieKommentarMuster/List.vue'),
          },
          {
            path: 'historiekommentarmuster/neu',
            name: 'messmittel.settings.historiekommentarmuster.neu',
            component: () => import('@/views/messmittelverwaltung/messmittel/settings/HistorieKommentarMuster/Index.vue'),
          },
          {
            path: 'historiekommentarmuster/:id',
            name: 'messmittel.settings.historiekommentarmuster.id',
            component: () => import('@/views/messmittelverwaltung/messmittel/settings/HistorieKommentarMuster/Index.vue'),
            props: true,
          },
        ],
      },
    ],
  },
];
